module.exports = __webpack_public_path__ + "static/media/anunciateNosotros.24d33bf0.png";